import { registerRootComponent } from 'expo';
import React from 'react';
import { AppRegistry } from 'react-native-web';
import App from './App';

// Carregar variáveis de ambiente
if (process.env.NODE_ENV === 'development') {
}

// Definições globais para compatibilidade
if (typeof global.process === 'undefined') {
  global.process = { env: {} };
}

// Definir __DEV__ se não existir
if (typeof __DEV__ === 'undefined') {
  global.__DEV__ = true;
}

// Definir variáveis de ambiente globalmente
if (typeof window !== 'undefined') {
  window.process = window.process || {};
  window.process.env = window.process.env || {};
  Object.assign(window.process.env, process.env);
}

// Registrar o componente raiz
AppRegistry.registerComponent('main', () => App);
AppRegistry.runApplication('main', {
  rootTag: document.getElementById('root') || document.getElementById('app')
});
